import { Flame } from "lucide-react";

export function Marquee({ items, accent = false }: { items: string[]; accent?: boolean }) {
  const row = [...items, ...items];
  return (
    <div className={`overflow-hidden border-y border-border ${accent ? "bg-chili-ink text-cream" : "bg-yellow text-charcoal"} ticker-pause`}>
      <div className="marquee flex whitespace-nowrap py-2.5 md:py-4">
        {row.map((t, i) => (
          <span key={i} className="font-display text-xl sm:text-2xl md:text-5xl px-4 sm:px-5 md:px-6 flex items-center gap-3 sm:gap-4 md:gap-6">
            {t}
            <Flame className="opacity-70 size-4 sm:size-5 md:size-7" />
          </span>
        ))}
      </div>
    </div>
  );
}
